export function setLoading(state, loading){
    state.loading = loading
}

export function setReportData(state,data){
    state.report_data = data
}

/*
    Limpiar todos los filtros que tiene y los datos del reporte.
 */
export function clearParams (state) {
    state.report_data = [];
    Object.assign(state.params, {
        type_integration : null,
        type_information_integration : null,
        is_error:1,
    });
    state.params.date = this.setDateRangeParam();
}

export function setDateRangeParam(state) {
    // Seteamos la fecha
    var dt = new Date();

    // Fecha Actual
    let d = `${dt.getFullYear()}-${(dt.getMonth() + 1).toString().padStart(2, '0')}-${dt.getDate().toString().padStart(2, '0')}`;

    // Hace 30 días
    dt.setDate(dt.getDate() - 30);
    let d1 = `${dt.getFullYear()}-${(dt.getMonth() + 1).toString().padStart(2, '0')}-${dt.getDate().toString().padStart(2, '0')}`;

    state.params.date = [
        d1,
        d,
    ];
}

export function setTypesIntegration (state,data){
    state.types_integration = data;
}

export function setTypesInformationIntegration (state,data){
    state.types_information_integration = data;
}



// WEBPACK FOOTER //
// ./src/modules/report-log/mutations.js